import { BlogPost } from './types';
import { 
  BookOpenIcon,
  CpuChipIcon,
  PrinterIcon
} from '@heroicons/react/24/outline';

import CompleteGuide from './posts/CompleteGuide';
import JPEG2000Guide from './posts/JPEG2000Guide';
import PrintPWNotes from './posts/PrintPWNotes';

export const blogPosts: BlogPost[] = [
  {
    id: 'print-pw-notes-white-background',
    title: 'How to Print PW Notes in White Background Free 100% | #PW #PhysicsWallah #Unacademy #eSaral #ALLEN',
    excerpt: 'Stop wasting 20+ hours per week making notes. Convert any EdTech lecture PDFs (Physics Wallah, Unacademy, eSaral, ALLEN) to clean, printable white background notes instantly — 100% free!',
    content: PrintPWNotes,
    date: 'January 1, 2026',
    readTime: '12 min read',
    icon: PrinterIcon,
    category: 'Student Hacks',
    slug: 'print-pw-notes-white-background'
  },
  {
    id: 'complete-notescrafter-guide',
    title: 'Complete Guide to NotesCrafter: Transform Your PDFs Like a Pro',
    excerpt: 'Master every feature of NotesCrafter with this comprehensive guide. From basic uploads to advanced enhancement techniques, learn how to turn dark lecture slides into perfect study notes.',
    content: CompleteGuide,
    date: 'November 9, 2025',
    readTime: '14 min read',
    icon: BookOpenIcon,
    category: 'Guides',
    slug: 'complete-notescrafter-guide'
  },
  {
    id: 'jpeg2000-pdfs-simple',
    title: 'JPEG2000 in PDFs: What It Is & How to Handle It',
    excerpt: 'Some PDFs don\'t work in browsers. Here\'s why and what to do about it.',
    content: JPEG2000Guide,
    date: 'November 4, 2025',
    readTime: '9 min read',
    icon: CpuChipIcon,
    category: 'Technical',
    slug: 'jpeg2000-pdfs-simple'
  }
];

